// El tope de presupuesto del formulario de venta y referidos, con el parser común del portal.
import { parseBudgetAmount } from '@/shared/patterns/Lifecycle/budgetAmount';

export const isBudgetAmount = (text: string): boolean => parseBudgetAmount(text).ok;

/** En centavos; `null` si está vacío. Solo se llama con un texto que ya pasó la validación. */
export function budgetCents(text: string): number | null {
    const amount = parseBudgetAmount(text);
    return amount.ok ? amount.cents : null;
}
